module.exports = __webpack_public_path__ + "img/camled.e3bd6dad.png";